export interface GetInspectionCountRequest {
  inspectionId?: number
  branchCodes: {
    from: string
    to: string
    not: boolean
  }[]
  collectionTypes: {
    from: string
    to: string
    not: boolean
  }[]
  shelfTypes: {
    from: string
    to: string
    not: boolean
  }[]
}

export function GetInspectionCountRequestToJSON(
  value: GetInspectionCountRequest
): any {
  return {
    inspection_id: value.inspectionId !== 0 ? value.inspectionId : undefined,
    branch_codes:
      value.branchCodes.length > 0
        ? value.branchCodes.map(value => {
            return {
              from: value.from !== '' ? value.from : undefined,
              to: value.to !== '' ? value.to : undefined,
              not: value.not ?? undefined
            }
          })
        : undefined,
    collection_types:
      value.collectionTypes.length > 0
        ? value.collectionTypes.map(value => {
            return {
              from: value.from !== '' ? value.from : undefined,
              to: value.to !== '' ? value.to : undefined,
              not: value.not ?? undefined
            }
          })
        : undefined,
    shelf_types:
      value.shelfTypes.length > 0
        ? value.shelfTypes.map(value => {
            return {
              from: value.from !== '' ? value.from : undefined,
              to: value.to !== '' ? value.to : undefined,
              not: value.not ?? undefined
            }
          })
        : undefined
  }
}
